// 3rd party
import { Component, OnInit, OnDestroy, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { MatSidenav } from '@angular/material';

// components
import { AppComponent } from 'app/app.component';
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';

// helpers
import { Helper } from 'app/shared/helpers/helper';

// services
import { InstrumentService } from 'app/instruments/shared/instrument.service';

@Component({
  selector: 'app-sample-list',
  templateUrl: './sample-list.component.html',
  styleUrls: ['./sample-list.component.css']
})
export class SampleListComponent implements OnInit, OnDestroy {

  @ViewChild('sidenavRight') sidenavRight: MatSidenav;

  cancelSidenavOpen: boolean = false;
  checkedItems: number = 0;
  checkedMenuItems: string[] = [];
  chkAll: boolean;
  columns: any[] = [
    { tag: 'st', name: 'Status', value: 'Translate.Status', isChecked: true, isIconColumn: true, tooltipValue: 'Translate.Status' },
    { tag: 'att', name: 'HasAttachment', value: 'Translate.HasAttachments', isChecked: true, isIconColumn: true, tooltipValue: 'Translate.HasAttachments' },
    { tag: 'c', name: 'Code', value: 'Translate.Code', isChecked: true },
    { tag: 'it', name: 'InstrumentType.Name', value: 'Assays.Class', isChecked: true },
    { tag: 'os', name: 'OrderService.Code', value: 'Translate.OrderService', isChecked: true },
    { tag: 'se', name: 'CurrentSector.Name', value: 'Translate.LaboratorySector', isChecked: false },
    { tag: 'ed', name: 'SampleExpirationDate', value: 'Assays.SampleExpirationDate', isChecked: true },
    { tag: 'cd', name: 'OrderService.ReceivingDate', value: 'Assays.ReceivingDate', isChecked: false },
    { tag: 'cp', name: 'CollectPlace', value: 'Assays.CollectPlaceName', isChecked: false }
  ];
  currentPage: number = 1;
  data: any[];
  filter: string;
  isCheckingAll: boolean = false;
  isLoading: boolean = false;
  isSearching: boolean = false;
  orderBy: string = 'code';
  overallCount: number = 1;
  pageSize: number = 25;
  qtVisibleColumns: number = this.columns.filter(c => c.isChecked).length;
  sampleLocal: number = 1;
  search: string = '';
  selectedItems: any[] = [];
  sortOrder: string = 'asc';
  subscribe: Subscription;
  totalPages: number = 1;

  constructor(
    private app: AppComponent,
    private el: ElementRef,
    private instrumentService: InstrumentService,
    public mainLayout: LayoutMainComponent,
    private renderer2: Renderer2,
    private router: Router
  ) { }

  ngOnInit() {
    this.refresh();
    this.checkColumnsPreferences();
  }

  ngOnDestroy() {
    this.subscribe.unsubscribe();
  }

  cboSelectedValueChanged() {
    this.refresh(this.search);
  }

  checkAll(ev) {
    this.isCheckingAll = true;
    this.data.forEach((item) => {
      item.checked = ev.source.checked;
    });
    this.isCheckingAll = false;
    this.checkedItems = this.data.filter(item => item.checked).length;
  }

  checkColumn(event, str: string) {
    event.stopPropagation();
    let idx = this.columns.findIndex(c => c.tag === str);
    if (idx === -1) {
      return;
    }

    if (this.columns.filter(c => c.isChecked).length === 1 && this.columns[idx].isChecked) {
      return;
    }

    this.columns[idx].isChecked = !this.columns[idx].isChecked;
    this.qtVisibleColumns = this.columns.filter(c => c.isChecked).length;

    this.saveColumnsPreferences(this.columns);
  }

  checkColumnsPreferences() {
    if (!localStorage.getItem('webview.sampleList.columns')) {
      this.saveColumnsPreferences(this.columns);
    }
    let savedColumns = JSON.parse(localStorage.getItem('webview.sampleList.columns'));

    this.columns.forEach(c => c.isChecked = savedColumns.findIndex(sc => sc === c.tag) !== -1);
    this.qtVisibleColumns = this.columns.filter(c => c.isChecked).length;
  }

  closeSidenav() {
    this.sidenavRight.close();
    this.router.navigate([`/${this.app.currentContact.Domain}/samples/`]);
  }

  enableSearch() {
    this.isSearching = !this.isSearching;
    this.search = '';
  }

  getStatusDescription(status: number) {
    return this.instrumentService.getStatusDescription(status, true);
  }

  getStatusIcon(status: number) {
    return this.instrumentService.getStatusIcon(status);
  }

  isColumnChecked(str: string): boolean {
    let idx = this.columns.findIndex(c => c.tag === str);
    if (idx === -1) {
      return false;
    }

    return this.columns[idx].isChecked;
  }

  nextPage(e) {
    this.currentPage = e;
    this.refresh();
  }

  openDetails(item: any) {
    if (this.cancelSidenavOpen) {
      this.cancelSidenavOpen = false;
      return;
    }

    this.router.navigate([`/${this.app.currentContact.Domain}/samples/${item.Identifier}`]);
    this.sidenavRight.open();
  }

  onSelectionChange() {
    if (!this.isCheckingAll) {

      if (this.data.filter(item => item.checked).length !== this.data.length && this.chkAll) {
        this.chkAll = false;
      }
      if (this.data.filter(item => item.checked).length === this.data.length && !this.chkAll) {
        this.chkAll = true;
      }

      this.selectedItems = this.data ? this.data.filter(d => d.checked) : [];
      this.checkedItems = this.selectedItems.length;
    }
  }

  prevent($event) {
    this.cancelSidenavOpen = true;
    $event.preventDefault();
  }

  previousPage(e) {
    this.currentPage = e;
    this.refresh();
  }

  refresh(search?: string, orderBy?: string, sortOrder?: string) {
    this.filter = '';
    this.selectedItems = this.data ? this.data.filter(d => d.checked) : [];
    if (search !== undefined) {
      this.search = search;
    }
    if (orderBy) {
      this.orderBy = orderBy;
    }
    if (sortOrder) {
      this.sortOrder = sortOrder;
    }
    if (this.sampleLocal !== undefined && this.sampleLocal !== -1 && !this.mainLayout.isMobile) {
      this.filter += (this.filter ? ', ' : '') + '"CurrentSector.Identifier_is not null"';
    }

    if (this.app.currentContact !== undefined && this.app.currentContact.Customer !== undefined) {
      this.filter += (this.filter ? ', ' : '') + '"Customer.Identifier_=\'' + this.app.currentContact.Customer.Identifier + '\'"';
    } else {
      this.filter += (this.filter ? ', ' : '') + '"Customer.Identifier_=\'ERROR\'"';
    }
    const lstSpinner = this.el.nativeElement.querySelectorAll('mat-spinner');
    for (let x = 0; x < lstSpinner.length; x++) {
      this.renderer2.setStyle(lstSpinner[x], 'display', 'block');
    }

    this.filter += (this.filter ? ', ' : '') + '"IsSample_=1"';
    let fields = '"' + this.columns.map(c => c.name).join('","') + '"';
    this.subscribe = this.instrumentService.get(null, this.search, this.orderBy, this.sortOrder, this.pageSize, this.currentPage, this.filter, fields).subscribe(data => {
      for (let x = 0; x < lstSpinner.length; x++) {
        this.renderer2.setStyle(lstSpinner[x], 'display', 'none');
      }

      this.data = Helper.deserialize(data.text());

      if (this.selectedItems) {
        this.data.forEach(d => d.checked = this.selectedItems.find(s => s.Identifier === d.Identifier && s.checked) ? true : false);
      }
      this.checkedItems = this.data.filter(d => d.checked).length;
      this.overallCount = this.data.length > 0 ? this.data[0].OverallCount : 0;
      this.totalPages = Helper.getTotalPages(this.pageSize, this.overallCount);
    });
  }

  saveColumnsPreferences(columns: any[]) {
    localStorage.setItem('webview.sampleList.columns', JSON.stringify(columns.filter(c => c.isChecked).map(c2 => c2.tag)));
  }

  searchData() {
    this.refresh(this.search);
  }

  setPageSize(n) {
    this.pageSize = n;
    this.currentPage = 1;
    this.refresh();
  }

  sortData(data) {
    this.refresh(undefined, data.orderBy, data.sortOrder);
  }
}



// WEBPACK FOOTER //
// ./src/app/assays/samples/sample-list/sample-list.component.ts